// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"f3e3003e","179":"4dcea72f","207":"67cf7ebd","330":"3c86a0f1","594":"20c10c4e"}[chunkId] + ".js";
};